<template>
  <div class="daily-functionality">
    <box :title="$t('search')">
      <div class="pa-2">
        <DailyDatePicker @getDate="getDailyList" />
      </div>
    </box>

    <box :title="$t('functionalityList')" class="mt-2">
      <template slot="top-action-view">
        <v-icon
          v-if="dailyList.length > 0 && visiblePrint"
          @click="print"
          color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div v-if="dailyList.length > 0">
        <div class="pa-1">
          <v-row>
            <v-col cols="12" sm="6">
              <div class="d-flex pa-1">
                <div class="red color-box"></div>
                <span class="px-1">غیبت</span>
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="d-flex pa-1">
                <div class="green color-box"></div>
                <span class="px-1">روز های تعطیل رسمی یا تعطیل توافقی</span>
              </div>
            </v-col>
          </v-row>
        </div>
        <ListItemDailyFunctionalityWeb
          :list="dailyList"
          class="hidden-sm-and-down"
          @onClickItem="onClickItem"
        />
        <ListItemDailyFunctionalityApp
          :list="dailyList"
          class="hidden-md-and-up"
        />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>

    <DailyFunctionalitySummary
      v-if="dailyList.length > 0"
      :totalPersonDayWork="totalPersonDayWork"
    />
  </div>
</template>

<script>
import ListItemDailyFunctionalityApp from "../../components/functionality/daily/ListItemDailyFunctionalityApp.vue";
import ListItemDailyFunctionalityWeb from "../../components/functionality/daily/ListItemDailyFunctionalityWeb.vue";
import DailyFunctionalitySummary from "../../components/functionality/daily/DailyFunctionalitySummary.vue";
import EosToastType from "../../model/EosToastType";
import EmptyList from "../../components/widget/EmptyList.vue";
import EosUtils from "../../utils/EosUtils";
import TextUtils from "../../utils/TextUtils";

export default {
  components: {
    ListItemDailyFunctionalityApp,
    ListItemDailyFunctionalityWeb,
    DailyFunctionalitySummary,
    EmptyList,
  },
  data() {
    return {
      totalPersonDayWork: {},
      dailyList: [],
      page: 1,
      perPage: 7,
      pages: [],
      emptyList: false,
      visiblePrint: false,
      beginDate: localStorage.getItem("beginDateFilter") != null ? localStorage.getItem("beginDateFilter") : "",
      endDate: localStorage.getItem("endDateFilter") != null ? localStorage.getItem("endDateFilter") : "",
    };
  },
  methods: {
    getDailyList(date1, date2) {
      if (date1 == "" || date2 == "") {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: this.$t("msg-choose-date"),
        });
        return;
      }
      
      this.beginDate = date1;
      this.endDate = date2;

      const params = new URLSearchParams();
      params.append("begindate", date1);
      params.append("enddate", date2);
      var perno = this.$store.state.auth.auth.username;
      params.append("perno", perno);

      this.$store
        .dispatch("getPersonDayWorksTotal", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            var dailyList = result.data.WebPersonDayWorks.WebWorkDayList;
            this.dailyList = dailyList;
            
            this.totalPersonDayWork = result.data.TotallPersonDayWork;
            if (dailyList.length == 0) {
              this.emptyList = true;
            }
            this.checkVisiblePrint();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
    },
    checkVisiblePrint() {
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var canPrint = false;

        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            canPrint = true;
            return false;
          }
          return true;
        });

        if (!canPrint) {
          var permission = this.$store.state.personel.personelDetail.Permission;
          if (permission[19].toString() == "1") {
            this.visiblePrint = true;
          }
        }
      }
    },
    print() {
      var dp = this.$store.state.auth.auth.username;
      let routeData = this.$router.resolve({
        name: "rpPersonelsDayWork",
        query: { BD: this.beginDate, ED: this.endDate, dp: dp },
      });
      window.open(routeData.href, "_blank");
    },
    onClickItem(item) {
      console.log(item);
      var query = {
        pid: item.PERNO.toString().trim(),
        DT: TextUtils.convertToEnglishDigits(item.DDATE.toString().trim()),
      };
      if (!EosUtils.isWebKartAdmin()) {
        this.$router.push({ name: "eosDayWorkDetail", query: query });
      }
    },
  },
};
</script>

<style>
.daily-functionality {
  background-color: var(--background) !important;
}
</style>